export default __webpack_public_path__ + "static/media/next.df5f1a37.svg";